export interface WebExperimentState {
  disableFeature: Record<string, any> | undefined;
}

export const initialState: WebExperimentState = {
  disableFeature: {},
};
